import { Pathnames } from 'next-intl/routing';

export const locales = ['en', 'de'];

export const pathnames: Pathnames<typeof locales> & Record<string, { pageName?: string }> = {
    '/': {
        en: '/',
        de: '/',
        pageName: 'Home Page'
    },
    '/program': {
        en: '/program',
        de: '/programm',
        pageName: 'Program List Page'
    },
    '/program/[contentId]': {
        en: '/program/[contentId]',
        de: '/programm/[contentId]',
        pageName: 'Program Detail Page'
    },
    '/program/[contentId]/[showingId]': {
        en: '/program/[contentId]/[showingId]',
        de: '/programm/[contentId]/[showingId]',
        pageName: 'Showing Detail Page'
    },
    '/specials/[showingTagId]': {
        en: '/specials/[showingTagId]',
        de: '/specials/[showingTagId]',
        pageName: 'Specials Detail Page'
    },
    '/deals/[dealSlug]': {
        en: '/deals/[dealSlug]',
        de: '/deals/[dealSlug]',
        pageName: 'Deals Detail Page'
    },
    '/announcements': {
        en: '/news',
        de: '/aktuelles',
        pageName: 'Announcements Page'
    },
    '/imprint': {
        en: '/imprint',
        de: '/impressum',
        pageName: 'Imprint Page'
    },
    '/accessibility-statement': {
        en: '/accessibility-statement',
        de: '/barrierefreiheitserklaerung',
        pageName: 'Accessibility Statement Page'
    },
    '/booking/[showingId]': {
        en: '/booking/[showingId]',
        de: '/buchung/[showingId]',
        pageName: 'Booking Page'
    },
    '/booking/embedded/[showingId]': {
        en: '/booking/embedded/[showingId]',
        de: '/buchung/embedded/[showingId]',
        pageName: 'Embedded Booking Page'
    },
    '/rent-a-cinema': {
        en: '/rent-a-cinema',
        de: '/kino-buchen',
        pageName: 'Rent A Cinema Page'
    },
    '/shop/embedded': {
        en: '/shop/embedded',
        de: '/shop/embedded',
        pageName: 'Embedded Shop Page'
    },
    '/embedded/shop': {
        en: '/embedded/shop',
        de: '/embedded/shop',
        pageName: 'Embedded Voucher Shop Page'
    },
    '/embedded/snack-shop': {
        en: '/embedded/snack-shop',
        de: '/embedded/snack-shop',
        pageName: 'Embedded Snack Shop Page'
    },
    '/embedded/login': {
        en: '/embedded/login',
        de: '/embedded/login',
        pageName: 'Embedded Login Page'
    },
    '/embedded/newsletter': {
        en: '/embedded/newsletter',
        de: '/embedded/newsletter',
        pageName: 'Embedded Newsletter Page'
    },
    '/birthday-at-the-cinema': {
        en: '/birthday-at-the-cinema',
        de: '/geburtstag-im-kino',
        pageName: 'Birthday At The Cinema Page'
    },
    '/quit-subscription': {
        en: '/quit-subscription',
        de: '/abo-kuendigen',
        pageName: 'Quit Subscription Page'
    }
};
// FIXME: This is causing TS linting issues. Maybe there is a dependency update missing?
// } satisfies Pathnames<typeof locales>;

// Default: `always`
export const localePrefix = 'always';

export type AppPathnames = keyof typeof pathnames;
